import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import * as FPT from '../../utility/fpt';
import AppStore from '../../stores/AppStore';
import { withRouter } from 'react-router-dom';
import templateData, { localsMessages } from '../../utility/getTemplateData';
import { hideLanguageSelector } from '../../utility/languageSelector';
import { hideSpinnerOverlay } from '../../utility/helper';
import Illustration from '../../components/illustrations/Illustration';
import ConfirmationBody from '../../confirmation/ConfirmationBody';
import _get from 'lodash/get';
import { isMobileOrInContext } from '../../utility/inContextDonation';

const messages = localsMessages('errors/paymentError');
const noAccountErrorMessage = _get(
  messages,
  'noAccountError',
  "We can't complete this donation. The receiver doesn't have a valid PayPal account."
);

class UnilateralError extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount = () => {
    hideSpinnerOverlay();
    hideLanguageSelector();
    FPT.trackPage(
      'main:donate:wps:guest:unilateral',
      'main:donate:wps:guest:unilateral:web::'
    );
  };

  render() {
    return (
      <div
        className={`donate_wrapper confirmation ${
          isMobileOrInContext() ? 'mobile_view' : ''
        }`}
      >
        <div className="ppvx_row">
          <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
            <Illustration type="warning" />
          </div>
        </div>
        <div className="ppvx_row">
          <div className="ppvx_col-12 text-center">
            <ConfirmationBody message={noAccountErrorMessage} />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(UnilateralError);
